import { ChangeEvent, Dispatch, FC, SetStateAction } from "react";
import {
  ProductAdminRequestDTO
} from "Interface";


interface BaseUOMSectionProps {
  formData: ProductAdminRequestDTO;
  setFormData: Dispatch<SetStateAction<ProductAdminRequestDTO>>;
  mode: "add" | "edit" | "view";
  open: boolean;
  toggleSection: () => void;
}

export const BaseUOMSection: FC<BaseUOMSectionProps> = ({
  formData,
  setFormData,
  mode,
  open,
  toggleSection,
}) => {
  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="font-body tracking-wider border rounded-md">
      <button
        type="button"
        onClick={toggleSection}
        className="w-full px-4 py-3 text-left flex justify-between items-center hover:bg-gray-50"
      >
        <h3 className="text-lg font-medium">Base UOM</h3>
        {open ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-chevron-up h-5 w-5"
          >
            <path d="m18 15-6-6-6 6" />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-chevron-down h-5 w-5"
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        )}
      </button>
      {open && (
        <div className="px-4 pb-4 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-500 mb-1">
              Base UOM
            </label>
            <select
              name="baseUom"
              value={formData.baseUom || "pcs"}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-md text-sm"
              disabled={mode === "view"}
            >
              <option value="pcs">PCS</option>
            </select>
          </div>
          {/* <div className="flex items-center justify-center gap-2 mt-5">
                        <input type="checkbox" disabled={mode === "view"} className="h-4 w-4" />
                        <label className="text-sm text-gray-700">Apply to all UOM</label>
                    </div> */}
        </div>
      )}
    </div>
  );
};
